module.exports = __webpack_public_path__ + "img/phone.98f8144b.webp";